<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> 예외관리 리스트
      </template>
      <b-row>
        <b-col sm="6">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage"  />
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || '검색'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='hash';so.skt='MD5';">MD5</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" v-show="!so.adv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="is_alive" slot-scope="row">
          <b-badge variant="success" v-if="!row.item.is_alive">Enable</b-badge>
          <b-badge v-else variant="secondary">Disable</b-badge>
        </template>
        <template slot="hash" slot-scope="row">{{row.item.hash}}</template>
        <template slot="cause" slot-scope="row">{{row.item.cause}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">조회</b-btn>
        </template>
      </b-table>

      <b-row>
        <b-col class="md-4">
          <div class="pull-right">
            <b-button size="sm" variant="success" @click="$router.push({ name: 'hash', params: { id : 'add' }})"> 신규등록 </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
    </b-card>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import { Api } from '@/service';

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  "adv" : false,
  "sk" : "", "sv" : "", "skt" : "", "opt" : { },
})

export default {
  data: () => {
    return {
      selected: 1,
      so : default_opt()
    }
  },
  computed: {
    fields() {
      return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'is_alive', label: 'Status', sortable: false, thStyle: 'width: 10%' },
        { key: 'hash', label: '해쉬', sortable: true, thStyle: 'width: 40%' },
        { key: 'cause', label: '설명', sortable: true },
        { key: 'func', label: '조회', sortable: false, thStyle: 'width: 10%' },
      ]
    },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    rowCount: function() { return this.so.totalRows || 0; }
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        target : 'hash', cmd : 'list',
        body : { sort : [], or : [], and : [{ name : 'is_del', value : false, op : '='}] },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and = [{ name : 'is_del', value : false, op : '='}, { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      console.log(so)
      return Api.WSFinder(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail: function(item) { this.$router.push(`hash/${item.id}`); },
  	hideList: function(e) { this.show = !e; console.log('hash.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') }
  },
  created: function() { console.log('hash.list.vue', 'created'); },
  destroyed: function() { console.log('hash.list.vue', 'destroyed'); },
  mounted: function() { console.log('hash.list.vue', 'mounted'); },
}
</script>
